import { findRowHeader, getParamValue } from '../../utils/workbook';

export const parseWorkbook = (state) => {
  const row_header_idx = findRowHeader(state.data_for_import.workbook);
  if (row_header_idx == -1) return;

  state.data_for_import.header = row_header_idx + 1;
  state.data_for_import.first_row = row_header_idx + 2;

  state.data_for_import.workbook[row_header_idx].forEach((param, idx) => {
    state.data_for_import.bom_parameters[idx] = getParamValue(param);
  });
};
